export default __webpack_public_path__ + "app/images/icons/search-magnifying-glass.png";